import React,{useEffect,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import API from '../utils/api';
const ROLES={
  general_manager:'总经理',
  manager:'项目经理',
  steward_chief:'内务主管',
  engineer:'工程',
  fire_control:'消控',
  order_staff:'秩序员',
  cleaner_chief:'保洁主管',
  cleaner:'保洁',
  steward:'管家',
  finance:'财务'
};
const ALLOWED=[
  'general_manager',
  'manager',
  'steward_chief',
  'engineer',
  'fire_control',
  'order_staff',
  'cleaner_chief',
  'cleaner',
  'steward',
  'finance'
];
export default function StaffReview(){
 const nav=useNavigate(),[rows,setRows]=useState([]),[roles,setRoles]=useState({}),[loading,setLoading]=useState(true);
 const load=()=>API.get('/staff-registration/requests').then(r=>{setRows(r.data||[]);const x={};(r.data||[]).forEach(a=>x[a.id]=a.approved_role||a.requested_role);setRoles(x);}).finally(()=>setLoading(false));
 useEffect(()=>{load();},[]);
 const review=async(r,decision)=>{let review_note='';if(decision==='rejected')review_note=window.prompt('拒绝原因（可留空）','')||'';
   if(!window.confirm(decision==='approved'?`确认通过 ${r.real_name}？岗位：${ROLES[roles[r.id]]}`:`确认拒绝 ${r.real_name}？`))return;
   try{const x=await API.post(`/staff-registration/requests/${r.id}/review`,{decision,role:roles[r.id],review_note});alert(x.data.message);load();}catch(e){alert(e.response?.data?.message||'审核失败');}};
 const sync=async(r)=>{if(!window.confirm(`确认向安居宝下发 ${r.real_name} 的物业通卡？\n固定房号：99栋03单元1层01室`))return;
   try{const x=await API.post(`/staff-registration/users/${r.user_id}/sync-access`);alert(x.data.message+'\\n任务：'+x.data.task_uuid);}catch(e){alert(e.response?.data?.message||'下发失败');}};
 return <div style={s.page}><div style={s.head}><button style={s.back} onClick={()=>nav(-1)}>← 返回</button><h2 style={s.h}>员工注册审核</h2></div>
 <div style={s.body}>{loading?'加载中...':rows.map(r=><div key={r.id} style={s.card}><div style={s.top}><b>{r.real_name}</b><span>{r.status==='pending'?'待审核':r.status==='approved'?'已通过':'已拒绝'}</span></div>
 <div style={s.line}>账号：{r.username}　手机号：{r.phone}</div><div style={s.line}>身份证：{r.id_card_no_masked||'审核后已清理申请表明文'}</div>
 <div style={s.photos}>{r.id_card_photo&&<img src={'/uploads/'+r.id_card_photo} style={s.photo} alt="身份证"/>}{r.face_photo&&<img src={'/uploads/'+r.face_photo} style={s.photo} alt="人脸"/>}</div>
 {r.status==='pending'&&<><select style={s.sel} value={roles[r.id]||r.requested_role} onChange={e=>setRoles({...roles,[r.id]:e.target.value})}>{ALLOWED.map(k=><option key={k} value={k}>{ROLES[k]}</option>)}</select>
 <div style={s.btns}><button style={{...s.btn,background:'#52c41a'}} onClick={()=>review(r,'approved')}>通过</button><button style={{...s.btn,background:'#ff4d4f'}} onClick={()=>review(r,'rejected')}>拒绝</button></div></>}
 {r.status==='approved'&&r.user_id&&<button style={{...s.btn,background:'#13a8a8',marginTop:10}} onClick={()=>sync(r)}>下发物业通卡</button>}
 </div>)}</div></div>;
}
const s={page:{minHeight:'100vh',background:'#f5f7fa'},head:{background:'#1a4a8a',color:'#fff',padding:15,display:'flex',alignItems:'center'},back:{border:0,background:'transparent',color:'#fff',fontSize:15},h:{margin:0,flex:1,textAlign:'center'},body:{maxWidth:680,margin:'0 auto',padding:14},card:{background:'#fff',borderRadius:12,padding:14,marginBottom:12},top:{display:'flex',justifyContent:'space-between',fontSize:16},line:{fontSize:13,color:'#777',marginTop:5},photos:{display:'flex',gap:10,marginTop:10,flexWrap:'wrap'},photo:{width:120,height:150,objectFit:'contain',background:'#eee',borderRadius:8},sel:{width:'100%',padding:10,marginTop:10,border:'1px solid #ddd',borderRadius:8},btns:{display:'flex',gap:10,marginTop:10},btn:{padding:'9px 18px',border:0,borderRadius:7,color:'#fff',fontWeight:700}};
